import { Component, Input } from '@angular/core';
import { StudentBtnSizeOption } from './student-btn-size-option';
import { StudentBtnTypeOption } from './student-btn-type-option';

@Component({
    selector: 'kh-student-btn',
    styleUrls: ['./student-btn.component.less'],
    templateUrl: './student-btn.component.html',
    standalone: false
})
export class StudentBtnComponent {
  @Input() public size = StudentBtnSizeOption.sm;
  @Input() public type = StudentBtnTypeOption.primary;
  @Input() public text = 'Button text';
  @Input() public disabled = false;
  @Input() public fillWidth = false;

  public sizes = StudentBtnSizeOption;
  public types = StudentBtnTypeOption;
}
